import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Table } from "antd";
import Intro from "./components/Intro";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import avatar2 from "../../assets/images/users/profile.png";
import Loading from "../../components/Common/Loading";

const Dashboard = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [toolList, setToolList] = useState([]);

  const { user } = useSelector((state) => state.User);

  // * get Dashboard details
  const getDashboardDetails = () => {
    setIsLoading(true);
    apiReq(url.GET_DASHBOARD_DETAILS, {}, "get", {
      Authorization: `Bearer ${user?.token}`,
    })
      .then((res) => {
        console.log(res);
        if (res.success) {
          setToolList(res.tools);
          setData(res.data);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        alert(err.apiStatus.statusMessage);
      });
  };

  // * get all tools
  const getAllTools = () => {
    setIsLoading(true);
    apiReq(url.GET_ALL_TOOLS + user?._id, {}, "get", {
      Authorization: `Bearer ${user?.token}`,
    })
      .then((res) => {
        if (res.success && res.data !== null) {
          setToolList(res.data);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  useEffect(() => {
    if (user?.role.title === "Admin") {
      getDashboardDetails();
    } else {
      getAllTools();
    }
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading && <Loading />}
        <Container fluid>
          <Intro />
          {data && (
            <Row>
              <Col xl={3}>
                <Card>
                  <CardBody>
                    <div className="d-flex">
                      <div className="flex-1 overflow-hidden">
                        <p className="text-truncate font-size-14 mb-2">
                          No. of employees
                        </p>
                        <h4 className="mb-0">{data?.employees}</h4>
                      </div>
                      <div className="text-primary">
                        <i className={"ri-user-2-line font-size-24"}></i>
                      </div>
                    </div>
                  </CardBody>
                  {/* <CardBody className="border-top py-2">
                    <div className="text-truncate">
                      <span className="text-muted">More</span>
                    </div>
                  </CardBody> */}
                </Card>
              </Col>
              <Col xl={3}>
                <Card>
                  <CardBody>
                    <div className="d-flex">
                      <div className="flex-1 overflow-hidden">
                        <p className="text-truncate font-size-14 mb-2">Tools</p>
                        <h4 className="mb-0">{data?.tools}</h4>
                      </div>
                      <div className="text-primary">
                        <i className={"ri-tools-line font-size-24"}></i>
                      </div>
                    </div>
                  </CardBody>
                  {/* <CardBody className="border-top py-2">
                    <div className="text-truncate">
                      <span className="text-muted">More</span>
                    </div>
                  </CardBody> */}
                </Card>
              </Col>
              <Col xl={3}>
                <Card>
                  <CardBody>
                    <div className="d-flex">
                      <div className="flex-1 overflow-hidden">
                        <p className="text-truncate font-size-14 mb-2">
                          Contact Enquiries
                        </p>
                        <h4 className="mb-0">{data?.enquiries}</h4>
                      </div>
                      <div className="text-primary">
                        <i className={"ri-contacts-book-line font-size-24"}></i>
                      </div>
                    </div>
                  </CardBody>
                  {/* <CardBody className="border-top py-2">
                    <div className="text-truncate">
                      <span className="text-muted">More</span>
                    </div>
                  </CardBody> */}
                </Card>
              </Col>
              <Col xl={3}>
                <Card>
                  <CardBody>
                    <div className="d-flex">
                      <div className="flex-1 overflow-hidden">
                        <p className="text-truncate font-size-14 mb-2">
                          Social News
                        </p>
                        <h4 className="mb-0">{data?.news}</h4>
                      </div>
                      <div className="text-primary">
                        <i className={"ri-newspaper-line font-size-24"}></i>
                      </div>
                    </div>
                  </CardBody>
                  {/* <CardBody className="border-top py-2">
                    <div className="text-truncate">
                      <span className="text-muted">More</span>
                    </div>
                  </CardBody> */}
                </Card>
              </Col>
            </Row>
          )}

          <div>
            <h4 className="mb-4">Tools</h4>
            <div className="tool_box_wrapper row">
              {toolList.map((item, index) => {
                return (
                  <div className="col-md-4">
                    <a
                      href={item.link}
                      target="_blank"
                      className="toolBox"
                      key={`tool${index + 2}`}
                    >
                      <div className="toolImg">
                        <img src={item.image} alt={item.title} width={50} />
                      </div>
                      <div className="toolbox_body">
                        <h5 className="tool_title text-center">{item.title}</h5>
                        <p className="text-muted text-center mb-0 description">
                          {item.description.length > 100
                            ? item.description.substring(0, 100) + "..."
                            : item.description}
                        </p>
                        {/* <div className="user_images d-flex justify-content-center">
                          {item.users.length > 0 ? (
                            <div className="users_group">
                              {item.users.map((user, index) => {
                                return (
                                  <div className="user_avatar" key={index}>
                                    <img
                                      src={user.image ? user.image : avatar2}
                                      alt={user.name}
                                      title={user.name}
                                    />
                                  </div>
                                );
                              })}
                            </div>
                          ) : (
                            "NA"
                          )}
                        </div> */}
                      </div>
                    </a>
                  </div>
                );
              })}
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default Dashboard;
